import React from 'react'
import { Box, Button } from '@mui/material'
import { Typography, CircularProgress } from '@mui/material'
import AppModal from '../AppModal'
import theme from '../theme'

interface Props {
  open: boolean
  onClose: () => void
  title: string
  message: string
  onConfirm: () => void
  isLoading: boolean
  confirmButtonText?: string
  cancelButtonText?: string
}

const ConfirmationModal = ({
  open,
  onClose,
  title,
  message,
  onConfirm,
  isLoading,
  confirmButtonText = 'Delete',
  cancelButtonText = 'Cancel'
}: Props) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      header={
        <Box>
          <Typography variant="heading-4">{title}</Typography>
        </Box>
      }
      footer={
        !isLoading && (
          <Box display="flex" gap={theme.space['16']}>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                width: '264px',
                height: '56px',
                borderRadius: theme.borders['rounded-10']
              }}
              onClick={onClose}
            >
              <Typography variant="ui-3">{cancelButtonText}</Typography>
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                width: '264px',
                height: '56px',
                borderRadius: theme.borders['rounded-10']
              }}
              onClick={onConfirm}
              disabled={isLoading}
            >
              <Typography variant="ui-3">{confirmButtonText}</Typography>
            </Button>
          </Box>
        )
      }
      content={
        isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100px'
            }}
          >
            <CircularProgress sx={{ color: theme.palette['accent-500'] }} />
          </Box>
        ) : (
          <Box
            sx={{
              marginTop: theme.space['32']
            }}
          >
            <Typography
              variant="body-12"
              sx={{
                whiteSpace: 'pre-line'
              }}
            >
              {message}
            </Typography>
          </Box>
        )
      }
    />
  )
}

export default ConfirmationModal
